import React from "react";
import { Button, Input } from "antd";
import DataTable from "../../DataTable/DataTable";
import { SearchOutlined } from "@ant-design/icons";

export const columns = (handlePolicyAction, pagination) => [
  {
    title: "SI NO",
    key: "si_no",
    render: (_, __, index) => {
      const pageIndex = pagination.current || 1;
      const pageSize = pagination.pageSize || 10;
      return (pageIndex - 1) * pageSize + index + 1;
    },
  },
  {
    title: "CORPORATE",
    dataIndex: "corporate",
    key: "corporate",
    sorter: (a, b) => (a.corporate || '').localeCompare(b.corporate || ''),
  },
  {
    title: "ENDORSEMENT TITLE",
    dataIndex: "endorsement_title",
    key: "endorsement_title",
    sorter: (a, b) => {
      const textA = a.endorsement_title?.props?.children || '';
      const textB = b.endorsement_title?.props?.children || '';
      return textA.localeCompare(textB);
    },
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder="Search Endorsement Title"
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => confirm()}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    onFilter: (value, record) => {
        const titleText = record.endorsement_title?.props?.children || '';
        return titleText.toLowerCase().includes(value.toLowerCase());
    },
    render: (text) => text, // Renders the <Link> component
  },
  {
    title: "ENDORSEMENT NUMBER",
    dataIndex: "endorsement_number",
    key: "endorsement_number",
    sorter: (a, b) => (a.endorsement_number || '').localeCompare(b.endorsement_number || ''),
  },
  {
    title: "TRANSACTION STATEMENT",
    dataIndex: "transaction_statement",
    key: "transaction_statement",
  },
  {
    title: "ADDITION PREMIUM",
    dataIndex: "addition_premium",
    key: "addition_premium",
    sorter: (a, b) => a.addition_premium - b.addition_premium,
  },
  {
    title: "DELETION PREMIUM",
    dataIndex: "deletion_premium",
    key: "deletion_premium",
    sorter: (a, b) => a.deletion_premium - b.deletion_premium,
  },
  {
    title: "NET PREMIUM",
    dataIndex: "net_premium",
    key: "net_premium",
    sorter: (a, b) => a.net_premium - b.net_premium,
  },
  {
    title: "CREATED AT",
    dataIndex: "created_at",
    key: "created_at",
    sorter: (a, b) => new Date(a.created_at.split('-').reverse().join('-')) - new Date(b.created_at.split('-').reverse().join('-')),
  },
];

const EndorseList = ({
  loading,
  filteredData,
  pagination,
  handlePolicyAction,
  onChange,
}) => {
  return (
    <DataTable
      columns={columns(handlePolicyAction, pagination)}
      dataSource={filteredData}
      pagination={pagination}
      loading={loading}
      onChange={onChange} // Pass the handler for pagination, filter, and sort changes
    />
  );
};

export default EndorseList;